const PromissoryNotesStatus = {
    DRAFT: 'DRAFT',
    PENDING_SIGNATURE: 'PENDING_SIGNATURE',
    SIGNED: 'SIGNED',
    VALID: 'VALID',
    ESPIRED: 'ESPIRED',
    CANCELLED: 'CANCELLED',
};

export default PromissoryNotesStatus;